import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'

//views
import Home from './views/Home'

const homePage: React.FC = () => {
  return (
    <Routes>
      <Route
        path={'/'}
        element={<Home />}
      />
    </Routes>
  )
}

export default homePage
